export default function EkgLine({ className = "" }) {
    return (
        <svg
            viewBox="0 0 600 14"
            preserveAspectRatio="none"
            className={`ekg-line ${className}`}
            aria-hidden="true"
        >
            <polyline
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="0,7 80,7 100,7 110,2 120,12 130,4 140,9 150,7 240,7 260,7 270,1 280,13 290,5 300,7 410,7 425,7 433,3 442,11 452,5 460,7 600,7"
            />
        </svg>
    );
}
